<template>
	<!-- 申请试用弹框 登录页面专用 -->
		<div> 
			<div id="cydnApply" class="cydnApply" style="z-index: 3333;"> 
			<div class="contentbox"> 
				<div class="colsecydnApply" @click="colseFn()">X</div>
				<h1 class="bluefont1">申请试用</h1>
				<h3>请完善以下信息，我们顾问会在一个工作日内与您联系</h3> 
				<p class="widthPC-55 grayfont margin-x-auto"><span class="red-font font-20">*</span>为必填项</p>
					<div id="applyform">
						<div class="formLine ">
							<span class="labelLeft"><span class="redfont">*</span>姓名</span>
							<input type="text" v-model="applydata.name"  placeholder="请输入您的姓名" name="name" id="name" class="inpurRight" />
						</div>
						<div class="formLine formLineHalf">
							<span class="labelLeft"><span class="redfont">*</span>手机号</span>
							<input type="text" v-model="applydata.mobile"    placeholder="请输入您的手机号" name="mobile" id="mobilenum"  class="inpurRight" />
						</div>
						<div class="formLine">
							<span class="labelLeft"><span class="redfont">*</span>政府/园区/机构/企业名称</span>
							<input type="text" v-model="applydata.company"    placeholder="请输入您的公司名称" name="company" id="enterprisename" class="inpurRight" />
						</div>
						<div class="formLine formLineHalf">
							<span class="labelLeft">您的职务</span>
							<input type="text" v-model="applydata.position"   placeholder="请输入您的公司职务" name="position" id="job" class="inpurRight" />
						</div>
						<div class="formLine formLineHalf">
							<span class="labelLeft">您的邮箱</span>
							<input type="text" v-model="applydata.email"   placeholder="请输入您的邮箱" name="email" id="email" class="inpurRight" />
						</div>
						<div class="formLine formLineHalf">
							<span class="labelLeft">备注</span>
							<textarea placeholder="请详细描述您的问题和需求，不超过200字" v-model="applydata.note"   maxlength="200" name="note" id="remark" class="inpurRight textareainp"></textarea>
						</div>  
						<p id="errtext" class="redfont">{{errtext}}</p> 
						<p style="text-align: center;"><span class="fsubmitbtn" @click="submitfun()">立即申请</span></p>
					</div>
				</div>   
			</div>
			<div class="formresultbox" id="formresultbox" v-show="hasResult">
				<div class="resultconbox">
					<div class="resultbox-close" @click="hasResult=false">X</div>
					<div class="resultcon">
						<h3 id="fialss">{{fialss}}</h3>
						<h4>如果您希望尽早试用体验，也可以直接联系我们。</h4>
						<div class="content-box">
							<p>联系电话：<span class="red-font">&nbsp;&nbsp;&nbsp;400 008 0552;&nbsp;&nbsp;&nbsp;0755-82571568</span></p>
							<p><span class="fl">微信扫码：</span>&nbsp;&nbsp;&nbsp;<span class="weixinimg"><img src="http://www.ocn.com.cn/static/images/zixuncode.png" alt="扫码咨询"/></span></p>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
	export default {
	  name: 'rightnav',
			data(){
				return{
					demonstrate:this.$api.demonstrate(),
					hide:false,
					operatBtn:true,
					userdata:"",
					iszsdn:this.$api.iszsdn(), 
					curWebsite:this.$api.getWebsiteType(), 
					showApply:false,hasResult:false,errtext:'',fialss:"您的需求已经提交！", 
					applydata:{name:'',mobile:"",company:"",position:"",email:"",note:""},
				}
			},
	  props: {
	    msg: String, 
					type:{default:1,require:false},//type =1 通用版 使用说明十大功能 type=2 登录专用 电话 微信 qq type=3 上海数据平台登录页面专用 只保留他们的联系方式和返回顶部
	  },
			created() {   
			},
			methods:{
				//将结果传给父组件引用的handerChrend函数中，这样父组件就能拿到子组件的值
				colseFn(){
					console.log('close');
					this.$emit('handerChrend', false);
				},
					// this.hide=true;
				returnTop() {
					document.getElementById('loginpage').scrollTo({
						top: 0,
						left: 0,
						behavior: "smooth"
					});
				},
				submitfun(){ 
					var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; 
					var _this=this;
					if(this.applydata.name == '') {
						this.errtext='姓名不能为空'; 
					} else if(this.applydata.mobile == '') {
						this.errtext='手机号不能为空'; 
					} else if(this.applydata.company == '') {
						this.errtext='企业名称不能为空'; 
					} else if(!reg_tel.test(this.applydata.mobile)) {
						this.errtext='请正确填写您的手机号码'; 
					} else {
						this.errtext=''; 
						console.log(this.applydata);
						jQuery.ajax({
							type:"post",
							url:'http://lian.ocn.com.cn/api/cyl/v1/userApply/trial',
							data:this.applydata,  
							success:function(result){ 
								console.log('applyform',result); 
							if(result.success) {
								_this.applydata={name:'',mobile:"",company:"",position:"",email:"",note:""};
							}else{
								_this.fialss='提交失败，请稍后再试！';
							}
							_this.showApply=false;
							_this.hasResult=true;
							} 
						}) 
					}
				},
				// feedbackFun(result){
				// 	console.log('applyform',result);
				// 	if(result.success) {
				// 	document.getElementById("cydnApply").style.display = "none"; 
				// 	document.getElementById("formresultbox").style.display = "block";
				// 		jQuery("#applyform input").val('');
				// 		jQuery("#applyform textarea").val('');
				// 	} else {
				// //			alert("提交失败，请稍候再试！");
				// 	document.getElementById("cydnApply").style.display = "none";
				// 	jQuery('#fialss').html('提交失败，请稍后再试！');
				// 	document.getElementById("formresultbox").style.display = "block"; 
				// 	} 
				// }
			}
			
	}
	
	
	
</script> 
<style lang="scss">
#applyform{
.redfont{
	font-size: 26px;
	color: #ff0000 !important;
}

}
</style>